import { createRouter } from './router/index';
import Vue from 'vue';
import App from './App.vue';
import titleMixin from './util/title';

Vue.mixin(titleMixin);

export function createApp() {
  const router = createRouter();
  const app = new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
  });

  return { app, router };
}



// WEBPACK FOOTER //
// ./src/App.js